import React from "react";
import { InfoRow } from "./InfoRow";
import { useTranslation } from "react-i18next";
import { FormInstance } from "antd";
import { getName } from "country-list";

interface PersonalInfoField {
  key: string;
  label: string;
  value: string;
  editable?: boolean;
}

interface PersonalInfoProps {
  form: FormInstance<IVisaRequestFormData>;
  handleEditClick?: (field: string) => void;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({
  form,
  handleEditClick,
}) => {
  const { t } = useTranslation();

  const personalFields: PersonalInfoField[] = [
    {
      key: "surname",
      label: t("registration_form.step2.surname"),
      value: form.getFieldValue("surname") || "",
      editable: true,
    },
    {
      key: "middle_and_given_name",
      label: t("registration_form.step2.given_name"),
      value: form.getFieldValue("middle_and_given_name") || "",
      editable: true,
    },
    {
      key: "date_of_birth",
      label: t("registration_form.step2.date_of_birth"),
      value: form.getFieldValue("date_of_birth")
        ? form.getFieldValue("date_of_birth").format("DD-MM-YYYY")
        : "",
      editable: true,
    },
    {
      key: "gender",
      label: t("registration_form.step2.gender"),
      value: form.getFieldValue("gender") || "",
      editable: true,
    },
    {
      key: "nationality",
      label: t("registration_form.step2.nationality"),
      value: form.getFieldValue("nationality")
        ? getName(form.getFieldValue("nationality"))
        : "",
      editable: true,
    },
    {
      key: "id_card",
      label: t("registration_form.step2.id_number"),
      value: form.getFieldValue("id_card") || "",
      editable: true,
    },
    {
      key: "email",
      label: t("registration_form.step2.email"),
      value: form.getFieldValue("email") || "",
      editable: true,
    },
    {
      key: "request_passport_number",
      label: t("registration_form.step3.passport_number"),
      value: form.getFieldValue("request_passport_number") || "",
      editable: true,
    },
    {
      key: "passport_place_of_issue",
      label: t("registration_form.step3.place_of_issue"),
      value: form.getFieldValue("passport_place_of_issue") || "",
      editable: true,
    },
    {
      key: "passport_type",
      label: t("registration_form.step3.visa_type"),
      value: (form.getFieldValue("passport_type") || "") + " passport",
      editable: true,
    },
    {
      key: "date_of_issue",
      label: t("registration_form.step3.date_of_issue"),
      value: form.getFieldValue("date_of_issue")
        ? form.getFieldValue("date_of_issue").format("DD-MM-YYYY")
        : "",
      editable: true,
    },
    {
      key: "passport_expiry_date",
      label: t("registration_form.step3.expiry_date"),
      value: form.getFieldValue("passport_expiry_date")
        ? form.getFieldValue("passport_expiry_date").format("DD-MM-YYYY")
        : "",
      editable: true,
    },
    {
      key: "religion",
      label: t("registration_form.step2.religion"),
      value: form.getFieldValue("religion") || "",
      editable: true,
    },
    {
      key: "place_of_birth",
      label: t("registration_form.step2.place_of_birth"),
      value: form.getFieldValue("place_of_birth") || "",
      editable: true,
    },
  ];

  return (
    <div className="max-w-7xl mx-auto py-4">
      <div className="grid grid-cols-1 md:grid-cols-2">
        {personalFields.map((field) => (
          <InfoRow
            key={field.key}
            fieldKey={field.key}
            label={field.label}
            value={field.value}
            editable={field.editable}
            handleEditClick={handleEditClick}
          />
        ))}
      </div>
    </div>
  );
};

export default PersonalInfo;
